import React, { Fragment, Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import IngredientsList from '~/containers/ingredientsList/ingredientsList';
import CreateStocktakeModal from '~/containers/createStocktakeModal/createStocktakeModal';

export default class IngredientsPage extends Component {
  state = {
    dropdownOpen: false,
    stocktakeModalOpen: false
  };

  toggleDropDownOpen = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  toggleStocktakeModal = () => {
    this.setState({ stocktakeModalOpen: !this.state.stocktakeModalOpen });
  };

  render() {
    const { dropdownOpen, stocktakeModalOpen } = this.state;
    const buttons = (
      <Fragment>
        <ButtonDropdown className="mr3" isOpen={dropdownOpen} toggle={this.toggleDropDownOpen}>
          <DropdownToggle caret>Stocktakes</DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={this.toggleStocktakeModal}>Create stocktake</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
        <Link to="/ingredients/create">
          <Button data-qa="ingredient-create" color="primary">
            New Ingredient
          </Button>
        </Link>
      </Fragment>
    );
    return (
      <Page>
        <TitleBar back="/settings" backText="Settings" title="Ingredients" button={buttons} />
        <IngredientsList />
        <CreateStocktakeModal
          isOpen={stocktakeModalOpen}
          onToggle={this.toggleStocktakeModal}
          onSuccess={this.toggleStocktakeModal}
        />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredients.jsx